export const translations = {
  loginUsername: 'Benutzername',
  loginPassword: 'Passwort',
  loginLoginButton: 'Anmelden',
  loginLogoAlt: 'SpitAS Logo',
  loginError: 'Ihr Benutzername oder Passwort sind nicht korrekt.',
  twoFactorCode: '2FA-Code',
  twoFactorVerifyButton: 'Code bestätigen',
  twoFactorSetupTitle: '2FA-Authentifizierung einrichten',
  twoFactorSetupInstructions: 'Bitte geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.',
  twoFactorVerifyTitle: '2FA-Code eingeben',
  twoFactorVerifyInstructions: 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.',
  twoFactorError: 'Der eingegebene Code ist ungültig. Bitte versuchen Sie es erneut.',
  footerCopyright: '© 2025 Spitas. Alle Rechte vorbehalten',
  footerLink: 'Kallysoft AG',
  formRequired: 'Dieses Feld is notwendig',
  homeHeader: 'Buchungen',
  clientsHeader: 'Kunden',
  menuHome: 'Buchungen',
  menuClients: 'Kunden',
  menuLogout: 'Abmelden',
  // Confirmation for logout action
  menuLogoutConfirmation: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
  weekdaySu: 'So',
  weekdayMo: 'Mo',
  weekdayTu: 'Di',
  weekdayWe: 'Mi',
  weekdayTh: 'Do',
  weekdayFr: 'Fr',
  weekdaySa: 'Sa',
  today: 'Heute',
  min: "'",
  collectedServicesAddService: 'Buchung hinzufügen +',
  collectedServicesNoServices: 'keine Buchungen',
  clientsLastVisited: 'Letzte besuchte',
  clientsAll: 'Alle',
  clientsSearch: 'Suchen',
  clientHeader: 'Kunde',
  clientMobile: 'Handy',
  clientPhone: 'Telefon',
  clientEmail: 'Email',
  clientAddress: 'Adresse',
  clientContacts: 'Kontakte',
  clientAdditionalInfo: 'Weitere Informationen',
  clientComment: 'Kommentare',
  clientDetails: 'Details',
  clientOldBookings: 'Alte Buchungen',
  clientNotFound: 'Kunde konnte nicht gefunden werden',
  clientNoServices: 'Keine Buchungen registriert',
  bookingHeader: 'Buchung',
  bookingNoServices: 'Keine Leistungen gebucht',
  bookingAddService: 'Neue Leistung +',
  bookingNoAvailableServicesTitle: 'Keine verfügbaren Leistungen',
  bookingNoAvailableServicesBody:
    'Für diesen Kunden stehen keine Leistungen zur Verfügung.',
  pageNotFoundHeader: '404',
  pageNotFoundText: 'Diese Seite konnte nicht gefunden werden.',
  pageNotFoundLink: 'Zurück zur Hauptseite',
  bookingSelect: 'Buchung auswählen',
  bookingServices: 'Leistungen',
  bookingStartTime: 'Start Zeit',
  bookingEndTime: 'Ende Zeit',
  bookingDuration: 'Dauer (in min)',
  bookingRemark: 'Bemerkung',
  bookingCancel: 'Abbrechen',
  bookingSubmit: 'Speichern',
  bookingDelete: 'Löschen',
  bookingDeleteConfirmation:
    'Sind Sie sicher das Sie diese Buchung löschen wollen?',
  bookingSubmitError:
    'Es ist ein Fehler aufgetreten, bitte sersuchen Sie es erneut.',
  filterAll:'Alle',
  filterScheduled:'Geplant',
  filterConnected:'Gebucht',
  fieldRequired: 'Dieses Feld is notwendig. ',
  minDurationValidation: "Dieses Feld mindest Dauer von {{duration}}'. ",
  durationValidation: "Die Dauer muss ein Multiples von {{duration}}' sein. ",
  booking: 'Buchung',
  appointment: 'Termin',
  // PWA install sheet
  pwaTitle: 'App installieren',
  pwaSubtitle:
    'Fügen Sie SpitAS zu Ihrem Startbildschirm hinzu, um schneller zu starten, offline zu arbeiten und ein besseres Erlebnis zu erhalten.',
  pwaCta: 'App installieren',
  pwaIosStepShare:
    'Tippen Sie in Safari unten auf das Teilen-Symbol.',
  pwaIosStepAdd: 'Wählen Sie „Zum Home-Bildschirm“ und bestätigen Sie.',
  pwaIosNote:
    'Hinweis: Auf iOS erscheint keine automatische Installationsabfrage. Nutzen Sie das Teilen-Menü, um die App hinzuzufügen.',
  pwaAndroidTip:
    'Tipp: Falls keine Abfrage erscheint, öffnen Sie das Menü (⋮) in Chrome und tippen Sie auf „App installieren“.',
  pwaCloseAria: 'Hinweis schließen',
  // PWA inline loader + results inside sheet (Android path)
  pwaInstallingMsg: 'Bitte bestätigen Sie die Installation im System-Dialog…',
  pwaInstalledMsg:
    'Installiert! Sie finden die App auf dem Startbildschirm oder im App-Drawer.',
  pwaDismissedMsg:
    'Installation abgebrochen. Sie können es später erneut versuchen.',
  pwaErrorMsg: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
} as const;
